import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';

import { State } from '../../../vista-usuario/vista-usuario.state';

@Component({
  selector: 'rpe-vista-registro-actividad-container',
  templateUrl: './vista-registro-actividad-container.component.html',
  styleUrls: ['./vista-registro-actividad-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaRegistroActividadContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {
    // todo - hacer este dispatch singleton
  }
}
